import { api } from 'redux/api/index.api';
import Analytics from 'utils/Analytics';

// Temporary mock API for groups (static data)

const IDS = [
  '01c9e96b-0b93d355-3b9d-4943-acee-8805955f9c6e',
  'b7a277a7-fadc0b1f-26b5-4800-97a1-33d935552c53',
  '3cc92beb-b7773002-0e8f-4d44-bf4b-151b2e69453b',
];

const groups = [
  {
    id: '01',
    name: 'Groupe 1',
    billable: true,
    created_by: IDS[0],
    updated_by: IDS[1],
    created_at: '2025-03-17T09:27:01.089507Z',
    updated_at: '2025-03-21T15:15:02.993499Z',
    members_ids: [IDS[0], IDS[1], IDS[2]],
  },
  {
    id: '02',
    name: 'Groupe 2',
    billable: false,
    created_by: IDS[1],
    updated_by: IDS[2],
    created_at: '2025-03-18T09:27:01.089507Z',
    updated_at: '2025-03-22T15:15:02.993499Z',
    members_ids: [IDS[1], IDS[2], IDS[0]],
  },
  {
    id: '03',
    name: 'Groupe 3',
    billable: true,
    created_by: IDS[2],
    updated_by: IDS[0],
    created_at: '2025-03-19T09:27:01.089507Z',
    updated_at: '2025-03-23T15:15:02.993499Z',
    members_ids: [IDS[2], IDS[0], IDS[1]],
  },
  {
    id: '04',
    name: 'Groupe 4',
    billable: false,
    created_by: IDS[0],
    updated_by: IDS[2],
    created_at: '2025-03-20T09:27:01.089507Z',
    updated_at: '2025-03-24T15:15:02.993499Z',
    members_ids: [IDS[0], IDS[2], IDS[1]],
  },
  {
    id: '05',
    name: 'Groupe 5',
    billable: true,
    created_by: IDS[1],
    updated_by: IDS[0],
    created_at: '2025-03-21T09:27:01.089507Z',
    updated_at: '2025-03-25T15:15:02.993499Z',
    members_ids: [IDS[1], IDS[0], IDS[2]],
  },
  {
    id: '06',
    name: 'Groupe 6',
    billable: false,
    created_by: IDS[2],
    updated_by: IDS[1],
    created_at: '2025-03-22T09:27:01.089507Z',
    updated_at: '2025-03-26T15:15:02.993499Z',
    members_ids: [IDS[2], IDS[1], IDS[0]],
  },
  {
    id: '07',
    name: 'Groupe 7',
    billable: true,
    created_by: IDS[0],
    updated_by: IDS[1],
    created_at: '2025-03-23T09:27:01.089507Z',
    updated_at: '2025-03-27T15:15:02.993499Z',
    members_ids: [IDS[0], IDS[1], IDS[2]],
  },
  {
    id: '08',
    name: 'Groupe 8',
    billable: false,
    created_by: IDS[1],
    updated_by: IDS[2],
    created_at: '2025-03-24T09:27:01.089507Z',
    updated_at: '2025-03-28T15:15:02.993499Z',
    members_ids: [IDS[1], IDS[2], IDS[0]],
  },
  {
    id: '09',
    name: 'Groupe 9',
    billable: true,
    created_by: IDS[2],
    updated_by: IDS[0],
    created_at: '2025-03-25T09:27:01.089507Z',
    updated_at: '2025-03-29T15:15:02.993499Z',
    members_ids: [IDS[2], IDS[0], IDS[1]],
  },
  {
    id: '10',
    name: 'Groupe 10',
    billable: false,
    created_by: IDS[0],
    updated_by: IDS[2],
    created_at: '2025-03-26T09:27:01.089507Z',
    updated_at: '2025-03-30T15:15:02.993499Z',
    members_ids: [IDS[0], IDS[2], IDS[1]],
  },
  {
    id: '11',
    name: 'Groupe 11',
    billable: true,
    created_by: IDS[1],
    updated_by: IDS[0],
    created_at: '2025-03-27T09:27:01.089507Z',
    updated_at: '2025-03-31T15:15:02.993499Z',
    members_ids: [IDS[1], IDS[0], IDS[2]],
  },
  {
    id: '12',
    name: 'Groupe 12',
    billable: false,
    created_by: IDS[2],
    updated_by: IDS[1],
    created_at: '2025-03-28T09:27:01.089507Z',
    updated_at: '2025-04-01T15:15:02.993499Z',
    members_ids: [IDS[2], IDS[1], IDS[0]],
  },
  {
    id: '13',
    name: 'Groupe 13',
    billable: true,
    created_by: IDS[0],
    updated_by: IDS[1],
    created_at: '2025-03-29T09:27:01.089507Z',
    updated_at: '2025-04-02T15:15:02.993499Z',
    members_ids: [IDS[0], IDS[1], IDS[2]],
  },
  {
    id: '14',
    name: 'Groupe 14',
    billable: false,
    created_by: IDS[1],
    updated_by: IDS[2],
    created_at: '2025-03-30T09:27:01.089507Z',
    updated_at: '2025-04-03T15:15:02.993499Z',
    members_ids: [IDS[1], IDS[2], IDS[0]],
  },
  {
    id: '15',
    name: 'Groupe 15',
    billable: true,
    created_by: IDS[2],
    updated_by: IDS[0],
    created_at: '2025-03-31T09:27:01.089507Z',
    updated_at: '2025-04-04T15:15:02.993499Z',
    members_ids: [IDS[2], IDS[0], IDS[1]],
  },
];

export const groupsApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchGroups: builder.query({
      // query: ({ workspace_id }) => ({
      // url: ``, //@todo : utiliser workspace_id pour définir si on call la route pour les workspaces ou les groups (workspace_id = null => groups)
      // method: 'GET',
      // }),

      // en attendant : pas d'appel réseau, on retourne les données mockées
      async queryFn() {
        return {
          data: {
            groups,
            offset: 0,
            limit: 25,
            count: 15,
          },
        };
      },
    }),
    fetchGroup: builder.query({
      // query: ({ id }) => ({
      //   url: `/groups/${id}`,
      //   method: 'GET',
      // }),

      // en attendant : pas d'appel réseau, on retourne les données mockées
      async queryFn({ id }) {
        const group = groups.find(g => g.id === id);
        if (!group) {
          return {
            error: {
              status: 404,
              data: { message: 'Group not found' },
            },
          };
        }
        return {
          data: group,
        };
      },
    }),
    fetchGroupMembers: builder.query({
      query: ({ projectId, groupId, searchValue }) => ({
        url: `/projects/${projectId}/groups/${groupId}/members`,
        method: 'POST',
        body: {
          search_term: searchValue,
        },
      }),
      providesTags: (result, error, { groupId }) => [{ type: 'GroupMembers', id: groupId }],
    }),
    addMembersToGroup: builder.mutation({
      query: ({ projectId, groupId, userIds }) => ({
        url: `/projects/${projectId}/groups/${groupId}/add-members`,
        method: 'POST',
        body: {
          user_ids: userIds,
        },
      }),
      invalidatesTags: (result, error, { groupId }) => [{ type: 'GroupMembers', id: groupId }],
    }),
    sharePlansAndFolders: builder.mutation({
      query: ({ projectId, groupId, planIds = [], folderIds = [] }) => ({
        url: `projects/${projectId}/groups/${groupId}/shared-items/share-plans`,
        method: 'POST',
        body: {
          plan_ids: planIds,
          folder_ids: folderIds,
        },
      }),
      invalidatesTags: ['Plans', 'GroupContent'],
      async onQueryStarted({ groupDetails, folderIds, planIds }) {
        Analytics.track('groups_plans_changed', {
          type: groupDetails?.is_default ? 'default' : 'private',
          count_folder: folderIds?.length || 0,
          count: planIds?.length || 0,
        });
      },
    }),
    removePlansAndFolders: builder.mutation({
      query: ({ projectId, groupId, planIds = [], folderIds = [] }) => ({
        url: `projects/${projectId}/groups/${groupId}/shared-items/remove-plans`,
        method: 'POST',
        body: {
          plan_ids: planIds,
          folder_ids: folderIds,
        },
      }),
      invalidatesTags: ['Plans', 'GroupContent'],
      async onQueryStarted({ groupDetails, folderIds, planIds }) {
        Analytics.track('groups_plans_changed', {
          type: groupDetails?.is_default ? 'default' : 'private',
          count_folder: folderIds?.length || 0,
          count: planIds?.length || 0,
        });
      },
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchGroupsQuery,
  useFetchGroupQuery,
  useFetchGroupMembersQuery,
  useAddMembersToGroupMutation,
  useSharePlansAndFoldersMutation,
  useRemovePlansAndFoldersMutation,
} = groupsApi;
